import type * as React from "react";

import { Slider as CrowSlider } from "@crow/ui/slider";

/** The design system's slider (`design-system/ui`): the filled part in the accent, one thumb per value. */
function Slider(props: React.ComponentProps<typeof CrowSlider>) {
	return <CrowSlider data-slot="slider" {...props} />;
}

export { Slider };
